var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data.categories !== undefined && _vm.data.series !== undefined)?_c('apexchart',{attrs:{"height":"250px","width":_vm.width ? _vm.width : '100%',"type":_vm.type ? _vm.type: 'line',"options":{
                chart: {
                    animations: {
                        enabled: false
                    }
                },
                title: _vm.compound ? 
                    { 
                        text: _vm.title.toUpperCase(),
                        align: 'center',
                        style: {
                            fontWeight: 'Bold'
                        } 
                    } : { 
                        text: '' 
                    },
                xaxis: {
                    type: 'datetime',
                    labels: {
                        show: !_vm.historic ? true : false,
                        datetimeUTC: false,
                    }
                },
                yaxis : _vm.compound ? 
                    {
                        title: { text: _vm.ytitle }
                    } : {
                        title: { text: '' }
                    },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '45%', //bar thickness
                    },
                },
                tooltip: {
                    x: {
                        show: true,
                        format: !_vm.historic ? 'HH:mm' : 'dd',
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: !_vm.historic ? 'smooth' : undefined,
                }
            },"series":!_vm.historic 
                ? _vm.data.series.map( s => { return { name: `Line ${parseInt(s.line) + 1} - ${s.prop === 'watts' ? 'kilowatts' : s.prop}`, data: s.data } })
                : _vm.data.series.map( s => ({ name: s.prop, data: s.data }) )}}):_c('p',[_vm._v("Loading ...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }